import React from "react"

import { Control } from "./styles"

const Play = ({ onClick }) => {
  return (
    <Control type="button" onClick={() => onClick()}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="32"
        width="32"
        viewBox="0 0 1200 1200"
      >
        <path d="M600 1200C268.65 1200 0 931.35 0 600S268.65 0 600 0s600 268.65 600 600-268.65 600-600 600zM450 300.45v599.1L900 600 450 300.45z" />
      </svg>
    </Control>
  )
}

export default Play
